import type { ApiConfig } from '../../types'

export const futureLinearHistoryApiConfig = {
  existSubType: false,
  fetchableRange: (730 * 24 - 1) * 60 * 60 * 1000, // 730 days in milliseconds
  limit: 100,
  order: 'desc',
  range: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
  requiresRange: true,
  type: 'future-linear-history',
} as const satisfies ApiConfig
